import React from 'react';
import { motion } from 'framer-motion';
import Loading from './Loading';

const LoadingAnimation = ({ progress }) => (
    <motion.div
        key="loading"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
    >
        <Loading progress={progress} />
    </motion.div>
);

export default LoadingAnimation;
